import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * P9209 module permission hook
 * pgCode = "pw9209f1" (SYS_Program)
 */
export function useP9209Permissions() {
  return useModulePermission(Modules.P9209);
}
